import React from 'react';
import { withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/styles';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { viAccountList, viAccountListCount } from 'lib/api/sales';

import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import TableContainer from 'components/molecules/MbTable';
import SwitchingArea from 'components/organisms/SwitchingArea';

const style = (theme) => ({});

let initParam = {};

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      params: initParam,
      dataCnt: [],
      list: [],
      loading: false,
    };
  }

  getDataCnt = () => {
    viAccountListCount()
      .then((response) => {
        const { data } = response.data;

        this.setState({
          ...this.state,
          dataCnt: data,
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          moreFetching: false,
          error: true,
        });
      });
  };

  componentWillMount() {
    this.getDataCnt();
  }

  componentDidUpdate(prevState) {
    // const { params: prevParams } = prevState;
    // const { params } = this.state;
  }

  /**
   * 필터 선택 관련
   */
  handleOnchangeFilter = (filterParam) => {
    const { params } = this.state;

    this.setState({
      ...this.state,
      params: { ...params, acctSt: filterParam },
    });
  };

  render() {
    const { classes, t } = this.props;
    const { params, dataCnt } = this.state;
    // header 및 body 컬럼 커스텀
    const customized = {
      STATS_DTTM: {
        makeHead: (headsMap) => {
          return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
        },
        makeBody: (rowObj, headsMap) => {
          const adverCnt = getHeadObj(headsMap, 'STATS_DTTM');
          const converAdverCnt = {
            ...adverCnt,
            format: 'YYYY-MM-DD',
          };
          return (
            <>
              {makeRowColumn(
                rowObj['STATS_DTTM'],
                converAdverCnt.type,
                converAdverCnt.format
              )}
            </>
          );
        },
      },
      DEPOSITOR: {
        merged: true,
      },
    };
    return (
      <>
        <SwitchingArea
          title={
            <>
              <InfoTitleArea
                title={t('현재 발행된 계좌 수') + ' : ' + dataCnt}
              />
            </>
          }
        >
          <>
            <TableContainer
              className={classes.root}
              dataReqPromise={viAccountList}
              params={{ ...params }}
              sort="desc"
              order="STATS_DTTM"
              dense={true}
              customized={customized}
              hasExcel
            />
          </>
        </SwitchingArea>
      </>
    );
  }
}

export default withTranslation()(withStyles(style)(List));
